import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Bot, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function PublicAgentPrivacy() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/public/booking/${slug}/privacy`).then((r) => setD(r.data)).catch(() => setErr(true)); }, [slug]);
  return (
    <div className="min-h-screen bg-slate-50" data-testid="agent-privacy-page">
      <main className="max-w-3xl mx-auto px-6 py-12 space-y-6">
        <Link to={`/prenota/${slug}`} data-testid="agent-privacy-back" className="inline-flex items-center gap-2 text-sm text-sky-700 hover:underline"><ArrowLeft className="h-4 w-4" />Torna alla prenotazione</Link>
        {err && <p data-testid="agent-privacy-error" className="text-slate-500">Informativa non disponibile.</p>}
        {d && <>
          <h1 className="font-display text-3xl font-bold tracking-tight flex items-center gap-3"><ShieldCheck className="h-7 w-7 text-emerald-600" />Informativa privacy</h1>
          <p className="text-sm text-slate-500">Titolare del trattamento: <b>{d.agent_name}</b> · Contatti privacy: {d.email}</p>
          {d.ai_enabled && (
            <section data-testid="agent-privacy-ai" className="rounded-xl border border-violet-200 bg-violet-50 p-5 text-sm text-violet-950 space-y-2">
              <p className="font-semibold flex items-center gap-2"><Bot className="h-4 w-4" />Assistente virtuale della prenotazione</p>
              {d.ai_notice.split("\n").map((p, i) => <p key={i}>{p}</p>)}
            </section>
          )}
          <article data-testid="agent-privacy-text" className="bg-white border border-slate-200 rounded-xl p-6 text-sm text-slate-700 leading-relaxed whitespace-pre-wrap">{d.text}</article>
          <p data-testid="agent-privacy-version" className="text-xs text-slate-400">Versione del {d.version.date} · impronta {d.version.hash.slice(0, 12)}</p>
        </>}
      </main>
    </div>
  );
}
